import { AvailableDeliveryMethodsDetail } from "interfaces/session/ShoppingCart";
import { DELIVERY_METHODS } from "../../../constant/action-constants";
import { selectedDeliveryMethodDetails } from "./selectedDeliveryMethodDetails";

export function isSurgeCostApplicable(availableDeliveryMethodsDetails: AvailableDeliveryMethodsDetail[]): boolean {
  const ShippingMethodDetails: any = selectedDeliveryMethodDetails(DELIVERY_METHODS.SHIPPING, availableDeliveryMethodsDetails);
  if (!ShippingMethodDetails) {
    return false;
  }
  return ShippingMethodDetails.remoteAreaSurchargeApplicable;
}
